// Lightweight localStorage cache.
//
// Design: data in this app is immutable per dataset. Once stats / charts
// have been computed for a given (selected dataset combination, active
// party-tag set), they remain valid forever until either:
//   - a new dataset is added or deleted,
//   - a committee is re-classified via Party Audit, or
//   - the user manually refreshes.
//
// So the cache is content-addressed by (scope, signature) and does NOT
// time out. Explicit invalidation by callers replaces TTL.

const NS = 'fec_lcache_v2';

function _key(scope, sig) {
  return `${NS}:${scope}:${sig || 'empty'}`;
}

export function readCache(scope, sig) {
  try {
    const raw = localStorage.getItem(_key(scope, sig));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.ts !== 'number') return null;
    return parsed.data;
  } catch (_) {
    return null;
  }
}

export function writeCache(scope, sig, data) {
  try {
    localStorage.setItem(_key(scope, sig), JSON.stringify({ ts: Date.now(), data }));
  } catch (_) {
    // Storage full / private mode — silently skip.
  }
}

export function readCacheMeta(scope, sig) {
  try {
    const raw = localStorage.getItem(_key(scope, sig));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.ts !== 'number') return null;
    return { ts: parsed.ts };
  } catch (_) {
    return null;
  }
}

export function clearScope(scope) {
  try {
    const prefix = `${NS}:${scope}:`;
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.startsWith(prefix)) localStorage.removeItem(k);
    }
  } catch (_) { /* ignore */ }
}

// Convenience: blow away every cached payload across all scopes. Called
// when a dataset is added/deleted/renamed since that can affect any combo.
export function clearAll() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.startsWith(`${NS}:`)) localStorage.removeItem(k);
    }
  } catch (_) { /* ignore */ }
}
